import { Component, Vue } from "vue-property-decorator";
import { CONSOLE_SOUNDS } from "@/resources/constants/sounds";
import moment from "moment";
import { i18n } from "@/resources/locales";
import { TOOLKIT } from "@/resources/constants/multiplayerToolkit";
import { CONFIG, ConfigInterface } from "@/resources/constants/system";
@Component({})
export default class ConsoleMessage extends Vue {
  onNewConsoleMessage(sound, description, fromUser): void {
    const consoleSounds = CONSOLE_SOUNDS;
    const audio = new Audio();
    const config: ConfigInterface = this.$store.getters["UserStore/getConfig"];

    if (sound !== "NO_SOUND") {
      const searchSound = consoleSounds.filter((a) => a.name === sound)[0].src;
      if (!config.notification.silenceNotification) {
        audio.src = searchSound;
        audio.autoplay = true;
        audio.play();
      }
    }
    const options = {
      body: this.getDescriptionIfToolkit(description, fromUser),
      image: "https://assets-pro.nubi.city/nubii-us-blue.png",
      icon: "/src/assets/images/logo/nubii_blue.png",
      silent: config.notification.silenceNotification,
    };
    if (document.hidden) {
      const notification = new Notification(
        this.getTitleIfToolkit(description, fromUser),
        options
      );
      setTimeout(notification.close.bind(notification), 5000);
    }
    this.$vs.notification({
      //icon: '<i class="fas fa-bell" style="color: #2b3d8e"></i>',
      //border: "primary",
      color: "primary",
      duration: "none",
      clickClose: false,
      position: "top-right",
      title: this.getTitleIfToolkit(description, fromUser),
      text: `${this.convertUrlToLink(
        this.getDescriptionIfToolkit(description, fromUser)
      )}<p style="text-align: end;font-size: 10px">${i18n.t(
        "labels.sentAt"
      )} ${moment().format("HH:mm")}</p>`,
      onDestroy: () => {
        audio.pause();
      },
    });
  }

  convertUrlToLink(text): any {
    if (this.isHtml(text)) return text.toString();
    // URLs starting with http://, https://, or ftp://
    const replacePattern1 =
      /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\\/%?=~_|!:,.;]*[-A-Z0-9+&@#\\/%=~_|])/gim;
    let replacedText = text.replace(
      replacePattern1,
      '<a style="color: aqua;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;hyphens: auto;" href="$1" target="_blank">$1</a>'
    );

    // URLs starting with "www." (without // before it, or it'd re-link the ones done above).
    const replacePattern2 = /(^|[^\\/])(www\.[\S]+(\b|$))/gim;
    replacedText = replacedText.replace(
      replacePattern2,
      '<a style="color: aqua;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;hyphens: auto;" href="http://$2" target="_blank">$2</a>'
    );

    // Change email addresses to mailto:: links.
    const div = document.createElement("p");
    div.innerHTML = replacedText;
    return replacedText;
  }
  isHtml(text): boolean {
    const regex = /<[^>]*>/;
    return regex.test(text);
  }

  getDescriptionIfToolkit(description, fromUser): any {
    return TOOLKIT.includes(description)
      ? i18n.t(`toolkit.${description}`, { name: fromUser.name })
      : description;
  }
  getTitleIfToolkit(description, fromUser): string {
    return TOOLKIT.includes(description)
      ? "Multiplayer Toolkit"
      : fromUser ? i18n.t("notifications.newConsoleMessage", { name: fromUser.name }).toString() : i18n.t("notifications.announcement").toString();
  }
}
